import React, { useState } from 'react';


export const planOptions = [
    {
        link: 
            process.env.NODE_ENV === 'development' ? 'https://buy.stripe.com/test_bIY9CLfZUcMOadO000' : '',
            priceId:
                process.env.NODE_ENV === 'development' ? 'price_1QzNTRIomkyxBjboqLPQd1pC' : '',
                price: 5,
                duration: '/month',
    },
    {
        link: 
            process.env.NODE_ENV === 'development' ? 'https://buy.stripe.com/test_4gwcOXbJEeUW99K5kl' : '',
            priceId:
                process.env.NODE_ENV === 'development' ? 'price_1QzNaYIomkyxBjbo58sWA90K' : '',
                price: 48,
                duration: '/year',
    },
    {
        link: 
            process.env.NODE_ENV === 'production' ? 'https://buy.stripe.com/test_bIY9CLfZUcMOadO000' : '',
            priceId:
                process.env.NODE_ENV === 'production' ? 'price_1QzNTRIomkyxBjboqLPQd1pC' : '',
                price: 5,
                duration: '/month',
    },
    {
        link: 
            process.env.NODE_ENV === 'production' ? 'https://buy.stripe.com/test_4gwcOXbJEeUW99K5kl' : '', //TODO: Change to production link
            priceId:
                process.env.NODE_ENV === 'production' ? 'price_1QzNaYIomkyxBjbo58sWA90K' : '',
                price: 48,
                duration: '/year',
    }
    
]

export const Pricing = () => {
    // const [selectedPlan, setSelectedPlan] = useState(null);

    // const handlePlanSelection = (plan) => {
    //     setSelectedPlan(plan);
    // }

    // return (
    //     <div>
    //         <h1>Pricing</h1>
    //         <div className="row">
    //             {planOptions.map((plan) => (
    //                 <div className="col-md-4" key={plan.priceId}>
    //                     <div className="card">
    //                         <div className="card-body">
    //                             <h5 className="card-title">{plan.price} {plan.duration}</h5>
    //                             <p className="card-text">{plan.description}</p>
    //                             <button className="btn btn-primary" onClick={() => handlePlanSelection(plan)}>Select Plan</button>
    //                         </div>
    //                     </div>
    //                 </div>
    //             ))}
    //         </div>
    //     </div>
    // )
}